export const aboutTranslations = {
  en: {
    // Main about page
    'about.title': 'About FMC',
    'about.subtitle': 'Building excellence since 1998, FMC Construction has been at the forefront of innovative construction solutions, delivering exceptional projects that stand the test of time.',
    
    // Story section
    'about.story.title': 'Our',
    'about.story.paragraph1': 'Founded with a vision to transform the construction industry through innovation, quality, and unwavering commitment to excellence.',
    'about.story.paragraph2': 'What started as a small family business has grown into one of the region\'s most trusted construction companies, known for delivering projects that exceed expectations and stand as testaments to our craftsmanship.',
    'about.story.paragraph3': 'Today, FMC continues to push boundaries, embracing new technologies and sustainable practices while maintaining the personal touch that has defined us for over two decades.',
    
    // Stats section
    'about.stats.years': 'Years of Excellence',
    'about.stats.projects': 'Projects Completed',
    
    // Journey section
    'about.journey.title': 'Our Journey',
    'about.journey.subtitle': 'From humble beginnings to industry leadership',
    
    // Values section
    'about.values.title': 'Core Values',
    'about.values.subtitle': 'The principles that guide every decision, every action, and every project we undertake.',
    'about.values.excellence.title': 'Excellence',
    'about.values.excellence.description': 'We pursue perfection in every detail, never settling for anything less than exceptional.',
    'about.values.integrity.title': 'Integrity',
    'about.values.integrity.description': 'Honest, transparent, and ethical in all our business relationships and practices.',
    'about.values.passion.title': 'Passion',
    'about.values.passion.description': 'We love what we do, and it shows in the quality and care we put into every project.',
    'about.values.collaboration.title': 'Collaboration',
    'about.values.collaboration.description': 'Working together with clients, partners, and communities to achieve shared success.',
    
    // Team section
    'about.team.title': 'Leadership Team',
    'about.team.subtitle': 'Meet the experienced professionals who lead FMC Construction with vision and expertise.',
    
    // CEO
    'about.team.ceo.name': 'John Smith',
    'about.team.ceo.position': 'Chief Executive Officer',
    'about.team.ceo.experience': '20+ years in construction management',
    'about.team.ceo.expertise1': 'Strategic Planning',
    'about.team.ceo.expertise2': 'Business Development',
    'about.team.ceo.expertise3': 'Team Leadership',
    
    // COO
    'about.team.coo.name': 'Sarah Johnson',
    'about.team.coo.position': 'Chief Operations Officer',
    'about.team.coo.experience': '18+ years in project operations',
    'about.team.coo.expertise1': 'Project Management',
    'about.team.coo.expertise2': 'Quality Control',
    'about.team.coo.expertise3': 'Process Optimization',
    
    // CTO
    'about.team.cto.name': 'Michael Chen',
    'about.team.cto.position': 'Chief Technical Officer',
    'about.team.cto.experience': '22+ years in engineering',
    'about.team.cto.expertise1': 'Technical Innovation',
    'about.team.cto.expertise2': 'Engineering Excellence',
    'about.team.cto.expertise3': 'Sustainability',
    
    // Awards section
    'about.awards.title': 'Awards & Recognition',
    'about.awards.subtitle': 'Our commitment to excellence has been recognized by industry leaders and organizations.',
    'about.awards.industry': 'Industry Awards',
    'about.awards.satisfaction': 'Client Satisfaction',
    'about.awards.quality': 'Quality Certified',
    'about.awards.sustainability': 'Sustainability Partner',
    
    // CTA section
    'about.cta.title': 'Ready to Work With Us?',
    'about.cta.subtitle': 'Join hundreds of satisfied clients who have chosen FMC Construction for their projects. Let\'s build something amazing together.',
    'about.cta.button1': 'Start Your Project',
    'about.cta.button2': 'View Our Work',
  },
  ar: {
    // Main about page
    'about.title': 'من نحن',
    'about.subtitle': 'نبني التميز منذ ١٩٩٨، كانت شركة إف إم سي للبناء في طليعة الحلول المبتكرة في البناء، وتقديم مشاريع استثنائية تصمد أمام اختبار الزمن.',
    
    // Story section
    'about.story.title': 'قصة',
    'about.story.paragraph1': 'تأسست برؤية لتحويل صناعة البناء من خلال الابتكار والجودة والالتزام الثابت بالتميز.',
    'about.story.paragraph2': 'ما بدأ كشركة عائلية صغيرة نما ليصبح واحدة من أكثر شركات البناء الموثوقة في المنطقة، معروفة بتقديم مشاريع تتجاوز التوقعات وتقف كشهادات على حرفيتنا.',
    'about.story.paragraph3': 'اليوم، تستمر إف إم سي في دفع الحدود، وتبني التقنيات الجديدة والممارسات المستدامة مع الحفاظ على اللمسة الشخصية التي عرفتنا لأكثر من عقدين.',
    
    // Stats section
    'about.stats.years': 'سنوات التميز',
    'about.stats.projects': 'مشاريع مكتملة',
    
    // Journey section
    'about.journey.title': 'رحلتنا',
    'about.journey.subtitle': 'من البدايات المتواضعة إلى القيادة الصناعية',
    
    // Values section
    'about.values.title': 'وقيمنا الأساسية',
    'about.values.subtitle': 'المبادئ التي توجه كل قرار وكل عمل وكل مشروع نقوم به.',
    'about.values.excellence.title': 'التميز',
    'about.values.excellence.description': 'نسعى للكمال في كل تفصيل، ولا نرضى بأقل من الاستثنائي.',
    'about.values.integrity.title': 'النزاهة',
    'about.values.integrity.description': 'صادقون وشفافون وأخلاقيون في جميع علاقاتنا التجارية وممارساتنا.',
    'about.values.passion.title': 'الشغف',
    'about.values.passion.description': 'نحب ما نفعله، ويظهر ذلك في الجودة والاهتمام الذي نضعه في كل مشروع.',
    'about.values.collaboration.title': 'التعاون',
    'about.values.collaboration.description': 'نعمل معاً مع العملاء والشركاء والمجتمعات لتحقيق النجاح المشترك.',
    
    // Team section
    'about.team.title': 'فريق القيادة',
    'about.team.subtitle': 'تعرف على المحترفين ذوي الخبرة الذين يقودون شركة إف إم سي للبناء بالرؤية والخبرة.',
    
    // CEO
    'about.team.ceo.name': 'جون سميث',
    'about.team.ceo.position': 'الرئيس التنفيذي',
    'about.team.ceo.experience': '٢٠+ عاماً في إدارة البناء',
    'about.team.ceo.expertise1': 'التخطيط الاستراتيجي',
    'about.team.ceo.expertise2': 'تطوير الأعمال',
    'about.team.ceo.expertise3': 'قيادة الفريق',
    
    // COO
    'about.team.coo.name': 'سارة جونسون',
    'about.team.coo.position': 'الرئيس التنفيذي للعمليات',
    'about.team.coo.experience': '١٨+ عاماً في عمليات المشاريع',
    'about.team.coo.expertise1': 'إدارة المشاريع',
    'about.team.coo.expertise2': 'مراقبة الجودة',
    'about.team.coo.expertise3': 'تحسين العمليات',
    
    // CTO
    'about.team.cto.name': 'مايكل تشين',
    'about.team.cto.position': 'الرئيس التنفيذي للتكنولوجيا',
    'about.team.cto.experience': '٢٢+ عاماً في الهندسة',
    'about.team.cto.expertise1': 'الابتكار التقني',
    'about.team.cto.expertise2': 'التميز الهندسي',
    'about.team.cto.expertise3': 'الاستدامة',
    
    // Awards section
    'about.awards.title': 'الجوائز والاعتراف',
    'about.awards.subtitle': 'التزامنا بالتميز تم الاعتراف به من قبل قادة الصناعة والمنظمات.',
    'about.awards.industry': 'جوائز الصناعة',
    'about.awards.satisfaction': 'رضا العملاء',
    'about.awards.quality': 'معتمد الجودة',
    'about.awards.sustainability': 'شريك الاستدامة',
    
    // CTA section
    'about.cta.title': 'مستعد للعمل معنا؟',
    'about.cta.subtitle': 'انضم إلى مئات العملاء الراضين الذين اختاروا شركة إف إم سي للبناء لمشاريعهم. دعنا نبني شيئاً مذهلاً معاً.',
    'about.cta.button1': 'ابدأ مشروعك',
    'about.cta.button2': 'شاهد أعمالنا',
  }
};
